import { getRoute } from "@utils/route";

export const HEALTH_INSURANCE_PAGE_URL = '/health-insurance';

export const routeHealthInsurancePage = () => getRoute(HEALTH_INSURANCE_PAGE_URL);
